














































































import { MediaItem } from "@/api/models";
import { bus } from "@/main";
import { SiteState, SubmissionState, UserState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import HelpWidget from "./HelpWidget.vue";
import SnippetItem from "./SnippetItem.vue";
import { saveFile, saveResource, publishSubmission, fetchImageMeta } from "../../api/methods";
import { emptyString, isNumeric, notEmptyString } from "../../api/validators";
import { validPlayerUrlType } from "../../api/media-providers";
import { validUploadTypes } from "../../.config";
import { applyImageSize, formatFileSize, getImageSize, matchInt, secsToTime } from "@/api/helpers";

@Component({
  components: {
    HelpWidget,
    SnippetItem,
  },
  filters: {},
})
export default class UploadForm extends Vue {
  @Prop({ default: "" }) objectId: string;
  @Prop({ default: "" }) mediaRef: string;
  @Prop({ default: "" }) mode: string;
  @Prop({ default: "" }) mediaItemId: string;
  @Prop({ default: true }) showWeb: boolean;
  @State("site") site: SiteState;
  @State("user") user: UserState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: any;

  file = null;

  percent = 0;

  activeTab = 0;

  resource = "";

  uploadErrorMsg = "";

  valid = false;
  validationWait = 10;

  remoteErrorMsg = "";

  style: any = {};

  initY = 0;
  initX = 0;

  fileSize = 0;

  stopped = false;

  calcTs() {
    return new Date().getTime() % (3600 * 1000);
  }

  get refId() {
    const parts = [this.objectId];
    if (notEmptyString(this.mediaItemId, 8)) {
      parts.push(this.mediaItemId);
    }
    return parts.join("/");
  }

  get maxUploadVideos() {
    const maxNumSetting = this.site.settings.get('max_uploaded_videos');
    return isNumeric(maxNumSetting)? parseInt(maxNumSetting, 10) : 4;
  }

  get maxFiles() {
    const maxNumSetting = this.site.settings.get('max_files_per_submission');
    return isNumeric(maxNumSetting)? parseInt(maxNumSetting, 10) : 100;
  }

  contextualKey(prefix = '') {
    const parts = [prefix];
    if (this.isPdfMode) {
      parts.push('pdf');
    } else if (!this.showWeb) {
      parts.push('profile');
    }
    return parts.join('_');
  }

  get formatHelpKey() {
    return this.contextualKey('format_help');
  }

  get uploadMediaHelpKey() {
    return this.contextualKey('upload_media_help');
  }

  objectRef() {
    return this.mediaRef === "work"
      ? this.refId
      : this.mediaRef.replace(/__/, "_" + this.calcTs() + "__");
  }

  handleResult(result) {
    const { modifiedAt } = result;
    if (modifiedAt) {
      this.submission.modifiedAt = new Date(modifiedAt);
    }
  }

  save() {
    const subId = this.submission._id;
    const objectRef = this.objectRef();
    saveFile(subId, objectRef, this.file, this.handleProgress).then(this.handleResult);
  }

  close() {
    bus.$emit("upload-ref", { type: "", refKey: "" });
    bus.$emit("cancel-upload", true);
  }

  stopUpdating() {
    this.percent = 0;
  }

  get isPdfMode() {
    return this.mode === 'pdf';
  }

  get hasUploadError() {
    return this.uploadErrorMsg.length > 5;
  }

  get hasRemoteError() {
    return this.remoteErrorMsg.length > 5;
  }

  get minImageSize() {
    const minSize = this.site.settings.get('min_image_size');
    const size = {width: 800, height: 800};
    if (minSize instanceof Array) {
      minSize.forEach(row => {
        const {key, value } = row;
        if (['width', 'height'].includes(key)) {
          size[key] = value;
        }
      })
    }
    return size;
  }

  get contextualMimeTypes() {
    const pdfType = 'application/pdf';
    const coreImageTypes = ["image/jpeg", "image/png"];
    return this.isPdfMode? [pdfType] : this.showWeb? validUploadTypes.filter(type => type !== pdfType) : coreImageTypes;
  } 

  get wrapperClasses() {
    const firstClass = this.showWeb? 'show-tab-nav' : 'hide-tab-nav';
    const cls = [firstClass];
    if (this.isPdfMode) {
      cls.push('pdf-mode');
    } else if (!this.showWeb) {
      cls.push('profile-mode');
    }
    return cls;
  }

  addResource() {
    const hasUri = notEmptyString(this.resource, 6);
    this.remoteErrorMsg = "";
    if (hasUri) {
      const validType = validPlayerUrlType(this.resource);
      const { valid, provider, type } = validType;
      if (valid) {
        const mime = [type, provider].join("/");
        const fileInfo = {
          filename: this.resource,
          type,
          title: "",
          sourceFilename: this.resource,
          mime,
        };
        saveResource(
          this.submission._id,
          this.objectId,
          fileInfo,
          "player"
        ).then((data) => {
          const { mediaItem, valid, modifiedAt } = data;
          if (valid) {
            this.saveMediaItem({
              type: "mediaItem",
              mediaItem,
              submissionID: this.submission._id,
              workID: this.objectId,
            });
            this.close();
            if (modifiedAt) {
              this.submission.modifiedAt = new Date(modifiedAt);
            }
          }
        });
      } else {
        this.remoteErrorMsg = "Invalid URL";
      }
    } else {
      this.remoteErrorMsg = "Please enter a Web URL";
    }
  }

  handleProgress(prog) {
    const proportion = prog.total / prog.loaded;
    const tick = 30 + this.fileSize / 76800;
    this.percent = proportion * 25;
    if (proportion >= 1) {
      for (let i = 0; i < 100; i++) {
        setTimeout(() => {
          const next = i + 26 < 100 ? i + 26 : 100;
          if (this.stopped) {
            this.percent = 100;
          } else {
            this.percent = next;
          }
          if (next >= 100) {
            this.close();
          }
        }, i * tick);
      }
    }
  }

  handleSave(data) {
    if (data instanceof Object) {
      const { type, modifiedAt } = data;
      if (type === "statement") {
        const { filename, statements } = data;
        const delay = 5000 + this.fileSize / 1536;
        if (
          notEmptyString(filename) &&
          statements instanceof Array &&
          statements.length > 0
        ) {
          const refKey = filename
            .split("-")
            .pop()
            .split(".")
            .shift()
            .replace(/_\d\d\d\d+$/, "");
          setTimeout(() => {
            this.assignSubmission({ ...this.submission, statements });
            this.$ls.set("submission", { ...this.submission, statements });
            const st = statements.find(s => s.type === refKey);
            const alt = st instanceof Object ? st.alt : '';
            bus.$emit(
              "statement-image",
              {
                filename,
                refKey,
                alt
              },
              delay
            );
            /* if (this.submission.submitted) {
              setTimeout(() => {
                publishSubmission(this.submission._id);
              }, 2000);
            } */
          }, 250);
        }
      } else {
        this.saveMediaItem(data);
      }
      const { mediaItem } = data;
      if (mediaItem instanceof Object) {
        const {filename, attributes, alt } = mediaItem;
        let fileRef = filename;
        const hasMeta = notEmptyString(alt);
        if (!hasMeta && attributes instanceof Object && typeof filename === 'string' && /(jpg|png)/.test(filename)) {
          const {width, height} = attributes;
          if (width * height > 4000000) {
            fileRef = applyImageSize(filename, 'preview').split('/').pop();
          }
          setTimeout(() => {
            fetchImageMeta(fileRef, this.submission._id, mediaItem._id).then(result => {
              if (result.valid) {
                if (result.altText) {
                  bus.$emit('alt-text-update', {
                    subId: this.submission._id,
                    mediaId: mediaItem._id,
                    altText: result.altText
                  });
                }
              }
            });
          }, 3000);
        }
      }
      if (modifiedAt) {
        this.submission.modifiedAt = new Date(modifiedAt);
      }
    }
  }

  saveMediaItem(data) {
    const { msg, workID, mediaItem } = data;
    const workIndex = this.submission.works.findIndex((w) => w._id === workID);
    if (workIndex >= 0 && mediaItem instanceof Object) {
      const work = this.submission.works[workIndex];
      const itemIndex = work.mediaItems.findIndex(
        (mi) => mi._id === mediaItem._id
      );
      const item = new MediaItem(mediaItem);
      if (itemIndex >= 0) {
        work.mediaItems[itemIndex] = item;
      } else {
        work.mediaItems.push(item);
      }
      this.assignSubmission(this.submission);

      this.$ls.set("submission", this.submission);
      setTimeout(() => {
        bus.$emit("media-saved", {
          workId: workID,
          mediaItemId: mediaItem._id,
          msg,
        });
      }, 2000);
    } else {
      bus.$emit('bad-file', msg);
      this.stopped = true;
      setTimeout(() => {
        this.stopped = false;
      }, 2500);
    }
  }

  matchSizeSettingKey(mime: string) {
    switch (mime) {
      case "image/jpeg":
        return {
          key: "max_stored_jpeg_size_mb",
          defSize: 5,
        };
      case "image/png":
        return {
          key: "max_stored_png_size_mb",
          defSize: 10,
        };
      case "image/gif":
        return {
          key: "max_stored_gif_size_mb",
          defSize: 5,
        };
      case "application/pdf":
        return {
          key: "max_stored_pdf_size_mb",
          defSize: 3,
        };
      case "model/glb":
        return {
          key: "max_stored_glb_size_mb",
          defSize: 10,
        };
      default:
        return {
          key: "max_stored_file_size_mb",
          defSize: 20,
        };
    }
  }

  matchMaxSize(mime: string) {
    const { key, defSize } = this.matchSizeSettingKey(mime);
    const maxSizeMB = this.site.settings.get(key);
    return matchInt(maxSizeMB, defSize);
  }

  numUploadedVideos() {
    const videoFormats = ['video/mp4', 'video/mpeg4'];
    const filterVideoUploads = (mi: MediaItem) => mi.size > 1000 && videoFormats.includes(mi.mime);
    return this.calcNumUploadedFiles(filterVideoUploads);
  }

  numUploadedFiles() {
    const sources = ['cloudinary', 'local'];
    const filterUploads = (mi: MediaItem) => mi.size > 1000 && sources.includes(mi.source);
    return this.calcNumUploadedFiles(filterUploads);
  }

  calcNumUploadedFiles(filterMethod) {
    if (filterMethod instanceof Function) {
      return this.submission.works.map(w => w.mediaItems.filter(filterMethod).length).reduce((a,b) => a + b, 0);
    } else {
      return 0;
    }
  }

  /*
  * Allow these file extensions of the mime type cannot be reliably detected
  */
  get contextualExtensions(): string[] {
    if (this.showWeb && !this.isPdfMode) {
      return ['glb'];
    } else {
      return [];
    }
  }

  validateFile() {
    this.valid = false;
    this.validationWait = 10;
    this.uploadErrorMsg = "";
    if (this.file.size > 128) {
      let mime = this.file.type.trim().toLowerCase();
      const extension = this.file.name.toLowerCase().split('.').pop();
      if (this.contextualMimeTypes.includes(mime) || this.contextualExtensions.includes(extension)) {
        if (extension === 'glb') {
          mime = 'model/glb';
        }
        const maxSizeInt = this.matchMaxSize(mime);
        const maxBytes = maxSizeInt * (1024 * 1024);
        if (this.file.size > maxBytes) {
          const fileType = mime
            .split("/")
            .pop()
            .toUpperCase();
          const formattedSize = formatFileSize(this.file.size);
          this.uploadErrorMsg = `${fileType} files larger than ${maxSizeInt}MB are not allowed. (Your file is ${formattedSize})`;
        } else {
          this.valid = this.numUploadedFiles() < this.maxFiles;
          if (!this.valid) {
            this.uploadErrorMsg = `You have reached the limit of ${this.maxFiles} uploaded files`;
          }
        }
      } else {
        this.uploadErrorMsg = "Please select a valid file format";
      }
      if (mime.startsWith("image/") && this.file.size < 1250 * 1000) {
        this.validationWait = this.file.size < 500 * 1000? 500 : 750;
        this.valid = false;
        getImageSize(this.file).then(size => {
          const { width, height } = size;
          if (isNumeric(width) && isNumeric(height)) {
            const minArea = this.minImageSize.width * (this.minImageSize.height / 2);
            const area = width * (height / 2);
            if ((width > this.minImageSize.width || height > this.minImageSize.height) && area >= minArea) {
              this.valid = true;
            }
          }
          if (!this.valid) {
            this.uploadErrorMsg = `The image does not meet the minimum size requirements of ${this.minImageSize.width} x ${this.minImageSize.height}px (detected: ${width} x ${height}px)`;
          }
        })
      } else if (mime === "video/mp4" && this.valid) {
        this.valid = this.numUploadedVideos() < this.maxUploadVideos;
        this.validationWait = this.valid? 750 : 125;
        if (this.valid) {
          const video = document.createElement("video");
          video.src = URL.createObjectURL(this.file);
          video.ondurationchange = () => {
            const maxVideoDurationSetting = this.site.settings.get(
              "video_file_max_duration"
            );
            const maxVideoDurationInt = matchInt(maxVideoDurationSetting, 120);
            if (video.duration > maxVideoDurationInt) {
              const time = secsToTime(video.duration);
              const maxTime = secsToTime(maxVideoDurationInt);
              this.uploadErrorMsg = `This video is too long: ${time}. Max length: ${maxTime}`;
            } else {
              this.valid = true;
            }
          };
        } else {
          this.uploadErrorMsg = `You have reached the maximum mp4 upload limit of ${this.maxUploadVideos}`;
        }
      }
    } else {
      this.uploadErrorMsg = "File may be empty";
    }
  }

  @Watch("file")
  changeFile() {
    if (this.file instanceof File) {
      this.validateFile();
      setTimeout(() => {
        if (this.valid) {
          const subId = this.submission._id;
          this.fileSize = this.file.size;
          const objectRef = this.objectRef();
          this.percent = 1;
          this.stopped = false;
          saveFile(subId, objectRef, this.file, this.handleProgress).then(
            this.handleSave
          );
        }
      }, this.validationWait);
      setTimeout(() => {
        this.uploadErrorMsg = "";
      }, 15000);
    }
  }
}
